import { render, staticRenderFns } from "./url.vue?vue&type=template&id=f2473af0&lang=pug&"
var script = {}
import style0 from "./url.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports